@if (invitationPreview?.senderUsername; as username) {
<aside
  class="mb-3 overflow-hidden rounded-lg border border-primary/30 bg-white bg-linear-to-br from-primary/40 via-white to-whiteshade p-2 text-left text-black shadow-sm dark:bg-black-dark dark:from-primary/25 dark:via-black-dark-light dark:to-black-dark dark:text-white sm:p-2.5"
  role="status"
>
  <div class="flex items-center gap-1.5">
    <div class="relative shrink-0">
      <app-user-avatar
        [name]="username"
        [picture]="invitationPreview?.senderPicture"
        [size]="52"
        class="block"
      />
      <span
        class="absolute -bottom-0.5 -right-0.5 flex h-[24px] w-[24px] items-center justify-center rounded-full bg-white shadow-sm"
        aria-hidden="true"
      >
        <span
          class="h-[14px] w-[14px] bg-black mask-[url(/assets/images/icons/diamond.svg)] mask-center mask-no-repeat mask-contain"
        ></span>
      </span>
    </div>
    <div class="min-w-0">
      <p
        class="m-0! text-[11px] font-bold uppercase tracking-wider text-greyer dark:text-borders-dark"
      >
        {{ "APP_INVITATION_LABEL" | translate }}
      </p>
      <p class="my-0.5! break-words text-[16px] font-bold leading-tight">
        {{ "APP_INVITATION_WELCOME" | translate: {username} }}
      </p>
      <p class="m-0! text-sm leading-[1.4] text-greyer dark:text-borders-dark">
        {{ "APP_INVITATION_WELCOME_BODY" | translate }}
      </p>
    </div>
  </div>
  @if (invitationGems.length) {
  <div
    class="mt-2 flex flex-wrap items-center justify-between gap-1.5 border-t border-black/10 pt-1.5 dark:border-white/15"
  >
    <p class="m-0! text-xs font-bold text-greyer dark:text-borders-dark">
      {{ "APP_INVITATION_RECENT_GEMS" | translate }}
    </p>
    <div class="flex items-center pl-1.5">
      @for (gem of invitationGems; track gem.cover) {
      <img
        [src]="invitationImagesDomain + '/' + gem.cover"
        [alt]="gem.title"
        class="-ml-1.5 h-[58px]! w-[40px]! rounded-md border border-black/10 object-cover shadow-md"
        [style.transform]="'rotate(' + ($index - 1.5) * 5 + 'deg)'"
        (error)="failedInvitationCovers.add(gem.cover)"
      />
      } @if ((invitationPreview?.gemCount ?? 0) > invitationGems.length) {
      <span
        class="ml-1 rounded-full bg-black/10 px-1 text-xs font-bold dark:bg-white/15"
        >+{{ (invitationPreview?.gemCount ?? 0) - invitationGems.length }}</span
      >
      }
    </div>
  </div>
  }
</aside>
}
<h1 class="text-center">{{ "CREATE_ACCOUNT" | translate }}</h1>
<form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
  <input
    type="text"
    formControlName="firstname"
    placeholder="{{ 'FIRSTNAME' | translate }}"
  />

  <input
    type="text"
    name="lastname"
    formControlName="lastname"
    placeholder="{{ 'LASTNAME' | translate }}"
  />

  <input
    type="text"
    name="username"
    formControlName="username"
    placeholder="{{ 'USERNAME' | translate }}*"
  />
  @if (signupForm.get('username')?.touched) { @if
  (signupForm.get('username')?.hasError('required')) {
  <div class="error">
    {{ "USERNAME" | translate }} {{ "IS_REQUIRED" | translate }}
  </div>
  } }

  <input
    type="email"
    name="email"
    formControlName="email"
    placeholder="{{ 'EMAIL' | translate }}*"
  />
  @if (signupForm.get('email')?.touched) { @if
  (signupForm.get('email')?.hasError('required')) {
  <div class="error">
    {{ "EMAIL" | translate }} {{ "IS_REQUIRED" | translate }}
  </div>
  } @if (signupForm.get('email')?.hasError('email')) {
  <div class="error">
    {{ "INVALID_EMAIL" | translate }}
  </div>
  } }

  <div class="password relative">
    <input
      [type]="showPassword ? 'text' : 'password'"
      type="password"
      name="password"
      formControlName="password"
      placeholder="{{ 'PASSWORD' | translate }}*"
    />
    <button
      class="showPassword block absolute w-[24px] h-[24px] top-[12px] right-[12px]"
      type="button"
      [ngClass]="{active: showPassword}"
      (click)="showPassword = !showPassword"
      (keyup)="onKeyUp($event, 'showPassword')"
      tabindex="0"
    >
      {{ "SEE_PASSWORD" | translate }}
    </button>
  </div>
  @if (signupForm.get('password')?.touched) { @if
  (signupForm.get('password')?.hasError('required')) {
  <div class="error">
    {{ "PASSWORD" | translate }} {{ "FIRSTNAME" | translate }}
  </div>
  } }

  <div class="password relative">
    <input
      [type]="showConfirmPassword ? 'text' : 'password'"
      name="confirm_password"
      formControlName="confirm_password"
      placeholder="{{ 'CONFIRM_PASSWORD' | translate }}*"
    />
    <button
      class="showPassword block absolute w-[24px] h-[24px] top-[12px] right-[12px]"
      type="button"
      [ngClass]="{active: showConfirmPassword}"
      (click)="showConfirmPassword = !showConfirmPassword"
      (keyup)="onKeyUp($event, 'showConfirmPassword')"
      tabindex="0"
    >
      {{ "SEE_PASSWORD" | translate }}
    </button>
  </div>
  @if (signupForm.get('confirm_password')?.touched) { @if
  (signupForm.get('confirm_password')?.hasError('required')) {
  <div class="error">
    {{ "PASSWORD_CONFIRM" | translate }} {{ "IS_REQUIRED" | translate }}
  </div>
  } }

  <app-country-select
    class="block w-full mb-3"
    [(value)]="userCountry"
    [language]="userLanguage"
    [required]="true"
  ></app-country-select>

  <app-legal-acceptance-controls
    [form]="signupForm"
  ></app-legal-acceptance-controls>

  @if (error) {
  <div class="error">
    {{ error.error.error | translate }}
  </div>
  }
  <button type="submit" class="signup-submit" [disabled]="signupDisabled">
    {{ submitButtonText }}
  </button>

  <app-social-login-buttons
    [disabled]="socialLoginDisabled"
    [termsVersion]="currentLegalVersions?.terms?.version"
    [privacyVersion]="currentLegalVersions?.privacy?.version"
    [invitationToken]="invitationToken"
  ></app-social-login-buttons>

  <div class="link mt-4">
    <a class="arrow-back text-white!" routerLink="/">{{
      "LOG_IN" | translate
    }}</a>
  </div>
</form>
